import { Component, signal } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-login',
  imports: [FormsModule],
  templateUrl: './login.html',
  styleUrl: './login.css',
})
export class Login {
  username = '';
  password = '';
  errorMessage = signal<string>('');
  isLoading = signal<boolean>(false);

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  onLogin() {
    // Reset error message
    this.errorMessage.set('');
    
    // Validate inputs
    if (!this.username || !this.password) {
      this.errorMessage.set('Por favor, ingrese usuario y contraseña');
      return;
    }

    // Set loading state
    this.isLoading.set(true);

    // Call authentication service
    this.authService.login(this.username, this.password).subscribe({
      next: (response) => {
        this.isLoading.set(false);
        // Navigate to home on successful login
        this.router.navigate(['/home']);
      },
      error: (error) => {
        this.isLoading.set(false);
        // Display error message
        this.errorMessage.set(
          error.error?.message || 
          'Error al iniciar sesión. Por favor, verifique sus credenciales.'
        );
      }
    });
  }
}
